import React, { MouseEvent, TouchEvent } from 'react'
import { GeojsonFeature } from 'types/GeojsonFeature'
import schweizTopology from 'lib/geodata/switzerland.json'
import { feature } from 'topojson-client'

interface MapProps {
  canHover: boolean
  canTouch: boolean
  geometryCollection: { type: string; geometries: GeojsonFeature[] }
  mapId: string
  mouseOverHandler: (id: number, event: MouseEvent | TouchEvent) => void
  pathGenerator: (feat: GeojsonFeature) => string
}

/**
 * Draw a choropleth map
 * @param {object} props
 * @param props.gemeinden
 * @param props.mouseOverHandler
 * @constructor
 */
export const EventListenerMap = ({
  canHover,
  canTouch,
  mapId = '',
  mouseOverHandler,
  pathGenerator
}: MapProps) => {
  const gemeindeFeatures: GeojsonFeature[] = feature(
    schweizTopology,
    schweizTopology.objects.gemeinden
  ).features

  function drawSwissMunicipalities(
    areas: GeojsonFeature[],
    areaIdProperty = 'Primary_ID',
    idGenerator = (property: string | number) => property
  ) {
    return areas.map((feature: GeojsonFeature) => {
      const municipalityId = idGenerator(feature.properties[areaIdProperty])

      let boundMouseOverHandler = (
        event: MouseEvent<SVGPathElement> | TouchEvent<SVGPathElement>
      ) => mouseOverHandler(municipalityId as number, event)
      let interactionHandlers = {
        onMouseOver: canHover ? boundMouseOverHandler : undefined,
        // Allow municipalities to be touched once the window is broad enough
        onTouchStart:
          canTouch && window.innerWidth > 600
            ? boundMouseOverHandler
            : undefined
      }

      return (
        <path
          key={municipalityId}
          d={pathGenerator(feature)}
          id={`${mapId}-gem-el-${municipalityId}`}
          {...interactionHandlers}
          className='gemeinde'
          fill='transparent'
        />
      )
    })
  }
  return (
    <g className='event listening municipalities'>
      {drawSwissMunicipalities(gemeindeFeatures)}
    </g>
  )
}
